import Inserter from "./Inserter";
import Table, { PrimaryKeyValues } from "./Table";

export default class Updater extends Inserter {
    private id: PrimaryKeyValues;

    constructor(table: Table, id: PrimaryKeyValues) {
        super(table);
        this.id = id;
        this.editedRow = table.editRow(id);
    }

}